import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonComp from '@components/UI/Button/Index';
import PageWrapper from '@components/UI/PageWrapper/Index';
import { NotFoundIcon } from '@components/UI/NotFoundIcon/Index';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleGoHome();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
    // eslint-disable-next-line
  }, []);

  return (
    <PageWrapper>
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          minHeight: '100vh',
          background: 'linear-gradient(120deg, #f5f6fa 80%, #e3f6fc 100%)',
          animation: 'fadein 0.5s',
        }}
      >
        <div className="text-center">
          <div className="mb-3">
            <NotFoundIcon />
          </div>
          <h2 className="display-6 fw-bold" style={{ color: '#2b97be' }}>
            Oops! Não encontramos a página
          </h2>
          <p className="mt-3" style={{ fontSize: 20, color: '#5a5a5a' }}>
            A página que você procurou não está disponível.<br />
            Talvez ela tenha sido removida, esteja em manutenção ou o endereço digitado esteja incorreto.
          </p>
          <div className="d-flex flex-column align-items-center gap-2 mt-4">
            <ButtonComp
              title="Voltar para a página inicial"
              className="btn btn-primary shadow"
              onClick={handleGoHome}
              buttonColor="#2b97be"
              classnameIcon="fa-solid fa-house"
              hoverMessage="Clique para retornar ao início"
            />
            <span style={{ fontSize: 14, color: '#b2b2b2', marginTop: 10 }}>
              Se precisar de ajuda, fale com o suporte.
            </span>
            <span style={{ fontSize: 13, color: '#b2b2b2' }}>
              Ou pressione <kbd>ESC</kbd> para voltar ao início
            </span>
          </div>
        </div>
      </div>
      <style>
        {`
          @keyframes fadein {
            from { opacity: 0 }
            to { opacity: 1 }
          }
          .btn.btn-primary:hover {
            background: #2291b2 !important;
            filter: brightness(1.08);
            box-shadow: 0 2px 12px 0 #2196f329;
            transform: scale(1.03);
          }
        `}
      </style>
    </PageWrapper>
  );
};

export default NotFound;
